import { Permissions } from '../../apis/graphql/types';
import { GlobalPermissions } from './types';

export const defaultPermissions: Permissions = {
  ADMIN_CREATE_PAYMENTS: false,
  ADMIN_DELETE_PAYMENTS: false,
  ADMIN_READ_PAYMENTS: false,
  ADMIN_RETRY_PAYMENTS: false,
  ADMIN_REFUND_PAYMENTS: false,
  ADMIN_UPDATE_PAYMENTS: false,
  ADMIN_UPDATE_THRESHOLD: false,
  APPLY_PROMO_CODE: false,
  BUILD_REPORT: false,
  CANCEL_LINE_ITEM: false,
  CLONE_LINE_ITEM: false,
  CONFIGURE_AD_TAG: false,
  CREATE_AD_ACCOUNT: false,
  CREATE_ASSET: false,
  CREATE_BRAND: false,
  CREATE_BROADCAST: false,
  CREATE_CAMPAIGN: false,
  CREATE_CREATIVE: false,
  CREATE_KERV_CREATIVE: false,
  UPDATE_KERV_CREATIVE: false,
  CREATE_INDUSTRY: false,
  CREATE_LINEITEM: false,
  CREATE_PAYMENTS: false,
  CREATE_REPORT: false,
  CREATE_USER: false,
  DELETE_AD_ACCOUNT: false,
  DELETE_BROADCAST: false,
  DELETE_CAMPAIGN: false,
  DELETE_CREATIVE: false,
  DELETE_CREATIVES: false,
  DELETE_LINE_ITEM: false,
  DELETE_ORGANIZATION: false,
  DELETE_PAYMENTS: false,
  DELETE_REPORT: false,
  DETACH_PROMO_CODE: false,
  GET_CAMPAIGN: false,
  GET_LINE_ITEM: false,
  INVITE_USER: false,
  PAUSE_LINE_ITEM: false,
  READ_AD_ACCOUNT: false,
  READ_ALL_ADS: false,
  READ_ALL_CAMPAIGNS: false,
  READ_ALL_LINE_ITEMS: false,
  READ_BRAND: false,
  READ_BROADCAST: false,
  READ_CAMPAIGN_LINEITEMS: false,
  READ_CREATIVE: false,
  READ_CREATIVES: false,
  READ_INDUSTRY: false,
  READ_LEGACY_REPORT: false,
  READ_NOTIFICATION: false,
  READ_ORGANIZATION: false,
  READ_OWN_USER: false,
  READ_PAYMENTS: false,
  READ_REPORT_TEMPLATE: false,
  READ_REPORT: false,
  READ_ROLES: false,
  READ_TARGETING: false,
  READ_USER: false,
  READ_USERS: false,
  RESUME_LINE_ITEM: false,
  SUBMIT_LINE_ITEM: false,
  SUSPEND_LINE_ITEM: false,
  UPDATE_AD_ACCOUNT_BILLING_CONTACT: false,
  UPDATE_AD_ACCOUNT_BRAND: false,
  UPDATE_AD_ACCOUNT_NAME: false,
  UPDATE_AD_ACCOUNT: false,
  UPDATE_BRAND: false,
  UPDATE_BROADCAST: false,
  UPDATE_CAMPAIGN: false,
  UPDATE_INDUSTRY: false,
  UPDATE_LINE_ITEM: false,
  UPDATE_NOTIFICATION_SETTINGS: false,
  UPDATE_ORGANIZATION: false,
  UPDATE_PAYMENTS: false,
  UPDATE_REPORT: false,
  UPDATE_USER: false,
  USER_STATUS_UPDATE: false,
  OVERRIDE_LINE_ITEM_PRICE: false,
};

export const defaultGlobalPermissions: GlobalPermissions = {
  roles: [],
  permissions: defaultPermissions,
  adAccountPermissions: {},
};
